import {FC} from "react";
import styled from "styled-components";
import {Grid, Skeleton, Tooltip, useMediaQuery} from "@mui/material";
import {Box} from "@mui/system";
import {useTheme} from "@mui/material/styles";
import {InfoCell} from "../../styles/Wrappers";
import {KpiCell} from "./kpiCells";

const Wrapper = styled(Grid)`
  display: unset !important;
`

const StyledGrid = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(169px,1fr));
  ${(props) => props.theme.breakpoints.down("md")} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${(props) => props.theme.breakpoints.down("sm")} {
    grid-template-columns: 1fr 1fr 1fr;
    .MuiBox-root {
      justify-content: center;
    }
  }
  gap: 1rem;
  padding-top: 24px !important;
`;

const Plug = styled.div`
  @media (max-width: 942px) {
    display: none;
  }
`

// the row of number cells at the top of a building area or property, expects cells sorted by sortKpiCells
export const KpiGrid: FC<{ cells: KpiCell[] }> = ({cells}) => {
  const theme = useTheme()
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Wrapper container spacing={3}>
      <StyledGrid item xs={12}>
        {cells.map((cell, index) => {
          if (cell.value === undefined) {
            return (
              <Skeleton
                key={index}
                height={48.39}
                variant="rectangular"
                animation="wave"
                style={{borderRadius: 0}}
              />
            )
          }
          if (cell.value === 0) {
            return <Plug key={index}/>
          }
          return (
            <Tooltip
              key={index}
              title={cell.title}
              enterTouchDelay={sm ? 0 : undefined}
              PopperProps={{sx: {top: '-18px !important'}}}
              disableHoverListener
              arrow
            >
              <InfoCell
                display={'flex'}
                alignItems={'center'}
                onClick={cell.onClick}
                style={{cursor: cell.onClick ? 'pointer' : 'default'}}
              >
                <span className={'number'}>{cell.value}</span>
                <Box className={'label'} display={'flex'} alignItems={'center'}>
                  <Box display={'flex'} justifyContent={'center'}>{cell.icon}</Box>
                  {!sm ? (<Box ml={1}><span>{cell.title}</span></Box>) : null}
                </Box>
              </InfoCell>
            </Tooltip>
          )
        })}
      </StyledGrid>
    </Wrapper>
  )
}
